import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fb6f6c7e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=fb6f6c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6f6c7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb6f6c7e')) {
      api.createRecord('fb6f6c7e', component.options)
    } else {
      api.reload('fb6f6c7e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fb6f6c7e&scoped=true&", function () {
      api.rerender('fb6f6c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/table-columns/form/index.vue"
export default component.exports